// extracted by mini-css-extract-plugin
module.exports = {"contenidorImatge":"IntroduccioIndividuFenofases_contenidorImatge__141Gx","element":"IntroduccioIndividuFenofases_element__1xD2U"};